import type { FC } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import { useFormStep } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/hooks/useFormStep";

interface ILLMSetupFooterProps {
    mainButtonText: string;
    secondaryButtonText: string;
    onMainButtonClick: () => void;
    onSecondaryButtonClick: () => void;
    isDisabled: boolean;
    isLoading: boolean;
}

export const LLMSetupFooter: FC<ILLMSetupFooterProps> = ({
    mainButtonText,
    secondaryButtonText,
    onMainButtonClick,
    onSecondaryButtonClick,
    isDisabled,
    isLoading,
}) => {
    const { stepFooterComponent: FooterComponent } = useFormStep();

    return (
        <Box
            padding="16px 24px"
            style={{
                borderTop: `1px solid ${colorsPalettes.carbon[100]}`,
            }}
        >
            <Flex
                alignItems="center"
                justifyContent={FooterComponent ? "space-between" : "flex-end"}
            >
                {FooterComponent ? <FooterComponent /> : null}
                <Flex justifyContent="flex-end">
                    <Button
                        type="flat"
                        onClick={onSecondaryButtonClick}
                        data-automation="llm-setup-secondary-button"
                    >
                        {secondaryButtonText}
                    </Button>
                    <Button
                        onClick={onMainButtonClick}
                        isDisabled={isDisabled}
                        isLoading={isLoading}
                        data-automation="llm-setup-main-button"
                    >
                        {mainButtonText}
                    </Button>
                </Flex>
            </Flex>
        </Box>
    );
};
